import api from "./api";
import axios from "axios";
import { ResponseInterface } from "../interfaces";

const baseURLAPI = process.env.REACT_APP_API_HOST;

export const getDollarExchangeRate = async (
  date: string,
  countryID: number = 236
): Promise<ResponseInterface<number>> => {
  const body = JSON.stringify({
    ValueDate: date,
    CountryID: countryID,
    CurrencyLocalID: 1,
    ExchangeCurrencyID: 2,
  });

  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const uri = `${baseURLAPI}/Currency/ExchangeRate`;

  try {
    const response = await api.post(uri, body, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: source.token,
    });

    if (response.status === 200) {
      return response.data;
    }
    return {
      model: null,
      didError: true,
      message: "",
      errorMessage: "Hubo un error al obtener los cupones disponibles",
    };
  } catch (error) {
    return (error as any)?.response?.data;
  }
};
